
class CenterQuestion {
  constructor() {
    this.init();
  }

  init() {
    this.id = undefined;
    this.type = undefined;
    this.question = undefined;
    this.hint = undefined;
    this.provider = false;
    this.form = undefined;
    this.required = false;
    this.is_active = true;
    this.internal = undefined;
    this.deposit_required = undefined;
    this.choices = undefined;
  }

  copy() {
    const cp = new CenterQuestion();

    cp.id = this.id;
    cp.type = this.type;
    cp.question = this.question;
    cp.hint = this.hint;
    cp.provider = this.provider;
    cp.form = this.form;
    cp.required = this.required;
    cp.is_active = this.is_active;
    cp.internal = this.internal;
    cp.deposit_required = this.deposit_required;
    if (this.choices) {
      cp.choices = [];
      this.choices.forEach((c) => {
        cp.choices.push({text: c.text, priority: c.priority});
      });
    }

    return cp;
  }

  buildFromJSON(obj) {
    this.init();
    if (obj) {
      this.id = obj.id ? obj.id.toString() : undefined;
      this.type = (obj.type && (['text', 'date', 'referral', 'html'].indexOf(obj.type) > -1)) ? obj.type : undefined;
      this.question = obj.question ? obj.question : undefined;
      this.hint = obj.hint ? obj.hint : undefined;
      this.provider = !!obj.provider;
      this.required = !!obj.required;
      this.is_active = (obj.is_active !== false); // Undefined treated as true
      this.internal = obj.internal ? obj.internal : undefined;
      this.deposit_required = obj.deposit_required ? obj.deposit_required : undefined;
      this.form = (obj.form && (['waitlist', 'deposit', 'both'].indexOf(obj.form) > -1)) ? obj.form : undefined;

      if (obj.choices) {
        this.choices = [];
        obj.choices.forEach((c) => {
          this.choices.push({text: c.text, priority: c.priority});
        });
      }
    }
  }

  toString() {
    let result = this.question ? this.question : '';
    return result;
  }

  getId() {
    return this.id;
  }

  setId(id) {
    this.id = id ? id.toString() : undefined;
  }

  getType() {
    return this.type;
  }

  setType(type) {
    if (!type) {
      this.type = undefined;
    } else if (['text', 'date', 'referral', 'html'].indexOf(type) > -1) {
      this.type = type;
    }
  }

  getQuestion() {
    return this.question;
  }

  setQuestion(question) {
    this.question = question;
  }

  getHint() {
    return this.hint;
  }

  setHint(hint) {
    this.hint = hint;
  }

  getProviderQuestion() {
    return this.provider;
  }

  setProviderQuestion(provider) {
    this.provider = provider;
  }
  
  getForm() {
    return this.form;
  }

  setForm(form) {
    if (!form) {
      this.form = undefined;
    } else if (['waitlist', 'deposit', 'both'].indexOf(form) > -1) {
      this.form = form;
    }
  }

  getRequired() {
    return this.required;
  }

  setRequired(required) {
    this.required = required;
  }

  getActive() {
    return this.is_active;
  }

  setActive(is_active) {
    this.is_active = is_active;
  }

  getInternal() {
    return this.internal;
  }

  setInternal(internal) {
    this.internal = internal;
  }
  
  getDepositRequired() {
    return this.deposit_required;
  }

  setDepositRequired(deposit_required) {
    this.deposit_required = deposit_required;
  }

  getChoices() {
    return this.choices;
  }

  setChoices(choices) {
    this.choices = undefined;
    if (choices) {
      this.choices = [];
      choices.forEach((c) => {
        this.choices.push({text: c.text, priority: c.priority});
      });
    }
  }
}

module.exports = CenterQuestion;
